module.exports = __webpack_public_path__ + "static/media/spinner.fbd839ac.svg";